<template>
  <span>
    <i :class="['el-rate__icon', (value === 0 ? 'el-icon-star-off' : 'el-icon-star-on'), (value > 0 ? 'star-good' : ''), (value < 0 ? 'star-bad' : '')]"></i>
    <i :class="['el-rate__icon', (Math.abs(value) > 1 ? 'el-icon-star-on' : 'el-icon-star-off'), (value > 1 ? 'star-good' : ''), (value < -1 ? 'star-bad' : '')]"></i>
    <i :class="['el-rate__icon', (value > 2 ? 'el-icon-star-on' : 'el-icon-star-off'), (value > 2 ? 'star-good' : '')]"></i>
    <i :class="['el-rate__icon', (value > 3 ? 'el-icon-star-on' : 'el-icon-star-off'), (value > 3 ? 'star-good' : '')]"></i>
    <i :class="['el-rate__icon', (value > 4 ? 'el-icon-star-on' : 'el-icon-star-off'), (value > 4 ? 'star-good' : '')]"></i>
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>

